module.exports = __webpack_public_path__ + "static/img/btn5.8d36dd9.png";


//////////////////
// WEBPACK FOOTER
// ./static/btn5.png
// module id = l5w4
// module chunks = 1